var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanBarcodeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    viewBox: "0 0 19.45 12.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727883",
    d: "M3.242 9.725V3.242h1.621v6.483zm9.725 0V3.242h1.621v6.483zm-7.294 0V3.242h.81v6.483zm1.621 0V3.242h1.621v6.483zm2.431 0V3.242h.81v6.483zm1.621 0V3.242h.81v6.483zm4.052 0V3.242h.81v6.483zm-.81-8.1h3.242v3.238h1.62V0h-4.862zM1.621 4.863V1.621h3.242V0H0v4.863zm3.242 6.483H1.621V8.1H0v4.863h4.863zM17.829 8.1v3.242h-3.241v1.621h4.862V8.1z",
    "data-name": "iconmonstr-barcode-3 (1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBarcodeIcon);
export default __webpack_public_path__ + "static/media/ScanBarcodeIcon.f51befe68758d48d1d5e20c2a1803244.svg";
export { ForwardRef as ReactComponent };